import * as React from "react";
import type { SVGProps } from "react";
const SvgPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#pin_svg__a)">
      <path d="M12 22c-.27 0-.53-.11-.72-.3C10.53 20.93 4 14.07 4 9.95 4 5.57 7.59 2 12 2s8 3.57 8 7.95c0 4.12-6.54 10.98-7.28 11.75-.19.19-.45.3-.72.3m0-18C8.69 4 6 6.67 6 9.95c0 2.5 3.84 7.22 6 9.59 2.16-2.37 6-7.09 6-9.59C18 6.67 15.31 4 12 4" />
      <path d="M12 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2" />
    </g>
    <defs>
      <clipPath id="pin_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPin;
